import { render } from "./AjustesPage.vue?vue&type=template&id=e31b04a6"
import script from "./AjustesPage.vue?vue&type=script&lang=js"
export * from "./AjustesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__